import { getIn } from 'formik';

const getFormError = (form, prop) => getIn(form.touched, prop) && getIn(form.errors, prop);

export default getFormError;
